<div class="info-screen">
  <div class="row">
    <div class="col-md-8">
      <div class="info-screen-text-container">
        <div class="content">
          <h1>
            {{ copy.heading }}
            <!-- <span class="highlight">{{ highlightedText }}</span> -->
          </h1>
          <p>
            {{ copy.intro }}
            <strong>{{ ineligibilityMessage }}</strong>
            {{ copy.outro }}
          </p>
          @if (ineligibilityDetails?.weightToLoseLbs) {
            <p>
              <strong>
                {{ copy.weightToLoseBefore }}
                {{ ineligibilityDetails?.weightToLoseLbs }}
                {{ copy.weightToLoseAfter }}
              </strong>
            </p>
          }
          <p class="contact-link">
            {{ copy.contactPrompt }}
            <a (click)="openContactModal()">{{ copy.contactLink }}</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
